import { getAllAffectedNodes } from './utils/all-affected.js';
import { isNotAGuard, isGuard } from './utils/is.js';
import { getTopCommonParent } from './utils/parenting.js';
import { orderByTabIndex } from './utils/tabOrder.js';
import { getFocusables } from './utils/tabUtils.js';

/**
 * traverses all related nodes (including groups) returning a list of all nodes(outer and internal) with meta information
 * This is low-level API!
 * @returns list of focusable elements inside a given top(!) node.
 * @see {@link getFocusableNodes} providing a simpler API
 */
var expandFocusableNodes = function (topNode) {
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(topNode, topNode, entries);
    var outerNodes = orderByTabIndex(getFocusables([commonParent], true), true, true);
    var innerElements = getFocusables(entries, false);
    return outerNodes.map(function (_a) {
        var node = _a.node, index = _a.index;
        return ({
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: isGuard(node),
        });
    });
};

export { expandFocusableNodes };
//# sourceMappingURL=focusables.js.map
